export default "__VITE_PUBLIC_ASSET__2dd646d2__"